import { ServiceLocator } from '../../app/ServiceLocator';
export interface QueryString {
  /**
    * Returns the query string part of the url as an object.
    * ex. http://localhost/?foo=bar -> { foo: 'bar' }
    */
  (): _.Dictionary<string>;

  /**
   * Sets only the query string parameter specified to the parameterValue.
   * The values of other QS parameters are not affected.
   * ex. QuerySting('foo', 'bar') -> http://localhost/?foo=bar
   */
  (parameter: string, parameterValue: any): void;
}

export function getQueryStringServiceFromAngular($location?: ng.ILocationService): QueryString {
  if (!$location) {
    $location = ServiceLocator.get<ng.ILocationService>('$location');
  }
  return $location.search.bind($location);
}
